import { useMemo } from 'react'
import { FaChevronRight } from 'react-icons/fa'

import { Image } from 'src/components/atoms/Image'
import { InternalLink } from 'src/components/atoms/Link'
import { Heading3 } from 'src/components/atoms/Typography'

export type DashboardActionPanelProps = {
  title: string
  actions: Array<{
    imgSrc?: string | JSX.Element
    title: string
    href: string
  }>
}

export const DashboardActionPanel = ({
  title,
  actions
}: DashboardActionPanelProps) => {
  const gridClasses = useMemo(() => {
    if (actions.length === 3) {
      return '@[768px]:grid-cols-3'
    }
    return '@[768px]:grid-cols-2 @[1024px]:grid-cols-4'
  }, [actions])

  return (
    <div className='min-w-auto sm:min-w-[390px] @container flex flex-col gap-5 bg-mostlyGreen rounded-[10px] p-5 sm:p-10'>
      <Heading3 className='text-white !m-0 !text-[18px] !leading-[26px] sm:!text-[28px] sm:!leading-[39px] !font-semibold'>
        {title}
      </Heading3>
      <div className={`grid grid-cols-1 gap-5 ${gridClasses}`}>
        {actions.map(({ title: actionTitle, imgSrc, href }) => (
          <InternalLink
            key={`action_${actionTitle}`}
            href={href}
            className='group flex flex-row items-center !text-mostlyGreen gap-[10px] bg-white rounded-[5px] py-[15px] sm:py-5 p-5'
          >
            {typeof imgSrc === 'string' ? (
              <Image
                className='w-[30px] h-[30px] sm:w-10 sm:h-10'
                width={40}
                height={40}
                alt={actionTitle}
                src={imgSrc}
              />
            ) : (
              imgSrc
            )}
            <span className='group-hover:text-primary flex-1 text-[16px] leading-[22px] font-medium sm:font-bold'>
              {actionTitle}
            </span>
            <FaChevronRight className='group-hover:text-primary group-hover:translate-x-1 transition-all' />
          </InternalLink>
        ))}
      </div>
    </div>
  )
}
